export default [
	{  // 产量统计
		path: 'production/statistics',
		name: 'm_production_statistics',
		component: () => import('@/pages/report/production_statistics')
	},
	{  // 员工绩效
		path: 'performance',
		name: 'm_performance',
		component: () => import('@/pages/report/performance')
	},
	{  // 工资报表
		path: 'salary',
		name: 'm_salary',
		component: () => import('@/pages/report/salary')
	},
	{  // 不良品项分布
		path: 'defectItems',
		name: 'm_defect_items',
		component: () => import('@/pages/report/defect_items')
	},
	{  // 不良品项汇总
		path: 'defectSummary',
		name: 'm_defect_summary',
		component: () => import('@/pages/report/defect_summary')
	},
	{  // 不良品项明细
		path: 'defectDetails',
		name: 'm_defect_details',
		component: () => import('@/pages/report/defect_details')
	},
	{  //生产报表
		path: 'production/report',
		name: 'm_production_report',
		component: () => import('@/pages/report/production_report')
	},
	{  //在制品报表
		path: 'in_process/product',
		name: 'm_in_process_product',
		component: () => import('@/pages/report/in_process_product')
	},
	{  //用料报表
		path: 'material_report',
		name: 'm_material_report',
		component: () => import('@/pages/report/material_report')
	}
];